<!--
 * @Description: 课程新增
 * @Author: shangao
 * @Date: 2022-04-14 09:10:46
 * @LastEditTime: 2022-05-06 15:48:34
 * @LastEditors: shangao
 * @FilePath: \teaching-web\src\views\manage\modify.vue
-->

<template>
  <!-- <div class="p-manage"> -->
  <!-- <AppHeader showMenu :showModule="false" /> -->
  <base-container :title="title" class="manage-course-create">
    <el-form :model="form" ref="form" :rules="rules" label-width="180px" class="u-form" size="small" label-suffix="：">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" :maxlength="32" placeholder="请填写课程名称"></el-input>
      </el-form-item>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="直播时间" prop="starttime">
            <!-- <el-date-picker v-model="form.time" type="datetimerange" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker> -->
            <!-- {{form.time}} -->
            <el-date-picker style="width:185px" v-model="form.starttime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" @change='selecttime'>
            </el-date-picker>
            -
            <el-date-picker style="width:185px" disabled v-model="form.endtime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主办单位" prop="organizer">
            <el-input v-model="form.organizer" :maxlength="32" placeholder="请填写主办单位"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学段" prop="phaseCode">
            <el-select v-model="form.phaseCode" placeholder="请选择学段" @change="axiosSubject">
              <el-option v-for="item in dictPhase" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <!-- <el-input
              v-model="form.phaseCode"
              placeholder="请填"
            ></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学科" prop="subjectCode">
            <el-select :disabled="!form.phaseCode" v-model="form.subjectCode" placeholder="请选择学科">
              <el-option v-for="item in dictSubject" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <!-- <el-input
              v-model="form.subjectCode"
              placeholder="请填写学科"
            ></el-input> -->
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="简介" prop="description">
        <el-input type="textarea" show-word-limit rows="4" maxlength="1000" placeholder="请填写简介" v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item label="视频上传" prop="recordingUrl">
        <!-- <el-upload
          action="/upload"
          ref="upload"
          :on-remove="onRemove"
          :auto-upload="false"
          multiple
          :limit="5"
          :on-exceed="onExceed"
          :file-list="file"
        > -->
        <MUpload v-model="form.recordingUrl" @change="getFileList" :accept="acceptVideo" :file-num-limit="1" />
        <div v-if="form.recordingUrl.length === 0" class="upload-tip1">
          <i class="el-icon-info"></i> 注：请先选择直播开始时间然后上传视频
        </div>
        <!-- <div class="u-upload-con">
            <el-button slot="trigger" size="small" type="primary" plain
              >上传</el-button
            >
            <div class="u-tip"><i class="el-icon-info"></i> 注：请上传视频</div>
          </div> -->
        <!-- </el-upload> -->
      </el-form-item>
      <el-form-item label="视频封面">
        <!-- <el-upload
          action="/upload"
          ref="upload"
          :on-remove="onRemove"
          :auto-upload="false"
          :on-exceed="onExceed"
          :file-list="file"
        >
          <div class="u-upload-con">
            <el-button slot="trigger" size="small" type="primary" plain
              >上传</el-button
            >
            <div class="u-tip"><i class="el-icon-info"></i> 注：请上传封面</div>
          </div>
        </el-upload> -->
        <MUpload v-model="form.thumbnail" :accept="acceptImage" list-type="picture" :file-num-limit="1" />
        <div v-if="form.thumbnail.length === 0" class="upload-tip">
          <i class="el-icon-info"></i> 注：请上传封面
        </div>
      </el-form-item>
      <el-form-item class="form-buttons">
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="onCancel">取消</el-button>
      </el-form-item>
    </el-form>
  </base-container>
  <!-- <AppFoot showCopyRight showLink :showContect="false" /> -->
  <!-- </div> -->
</template>

<script>
const moment = require('moment');
import baseContainer from './baseContainer.vue'
import MUpload from '@/components/Upload'
import { axiosFactory } from '@/services/axios-factory' 
import uuid from '@/utils/uuid'
const cloneDeep = require('lodash.clonedeep')
const pick = require('lodash.pick')
export default {
  components: {
    baseContainer,
    MUpload,
  },
  data() {
    return {
      id: this.$route.query.id,
      file: [],
      form: {
        name: '',
        time: [],
        starttime: '',
        endtime: "",
        organizer: '',
        phaseCode: '',
        subjectCode: '',
        description: '',
        recordingUrl: [],
        thumbnail: []
      },
      rules: {
        name: { required: true, message: '请填写课程名称' },
        starttime: { required: true, message: '请填写直播时间' },
        organizer: { required: true, message: '请填写主办单位' },
        phaseCode: { required: true, message: '请选择学段' },
        subjectCode: { required: true, message: '请选择学科' },
        description: { required: true, message: '请填写简介' },
        recordingUrl: { required: true, message: '请上传视频' },
      },
      // pickerOptions: {
      //   disabledDate (picker) {
      //     const date = new Date().getTime() - 3600 * 1000 * 24
      //     return date > picker.getTime()
      //   }
      // },
      dictPhase: [
        // { label: '幼儿园', value: '01' },
        { label: '小学', value: '03' },
        { label: '初中', value: '04' },
        // { label: '高中', value: '05' },
        // { label: '特殊教育', value: '09' }
      ],
      dictSubject: [],
      acceptVideo: {
        title: '视频',
        extensions: 'mp4',
        mimeTypes: 'video/mp4'
      },
      acceptImage: {
        title: '图片',
        extensions: 'gif,jpg,jpeg,bmp,png',
        mimeTypes: 'image/*'
      },
      videoDuration: 0
    }
  },
  computed: {
    title() {
      return this.id ? '编辑课程' : '课程新增'
    }
  },
  created() {
    this.getPhase()
    // 编辑-获取课程信息
    if (this.id) this.axiosData()
  },
  methods: {
    // 获取课程
    async axiosData() {
      const url = 'live/getLiveById'
      const params = { id: this.id }
      
      const { data } = await axiosFactory({ url, params })
      
      if (data.id) {
        let _this = this
        console.log("wwww",data.recordingFile.previews.mp4);
        let videoElement = document.createElement('video');
       let previes =  data.recordingFile.previews.mp4.replace('http://', 'https://');
        videoElement.src =previes;
        debugger 
        videoElement.addEventListener('loadedmetadata', function () {
          // 视频时长值的获取要等到这个匿名函数执行完毕才产生
          _this.videoDuration = Math.ceil(videoElement.duration)
        })
        // data.time = [data.startTime, data.endTime]
        data.starttime = data.startDate
        data.endtime = data.endDate
        data.recordingUrl = []
        if (data.recordingFile) {
          const { filename, contextId, md5, url, length } = data.recordingFile
          const extension = url.substring(url.lastIndexOf('/') + 1)
          data.recordingUrl = [{
            id: uuid(),
            status: 'complete',
            fileName: filename || extension,
            fileSize: length,
            url: url,
            md5,
            contextId
          }]
        } else if (data.recordingUrl) {
          // 兼容老数据
          const lastIndex = data.recordingUrl.lastIndexOf('/')
          if (lastIndex !== -1) {
            const fileName = data.fileName || data.recordingUrl.substring(lastIndex + 1)
            data.recordingUrl = [{
              id: uuid(),
              status: 'complete',
              fileName: fileName,
              url: data.recordingUrl
            }]
          }
        }

        data.thumbnail = data.thumbnail ? [{ id: uuid(), url: data.thumbnail, status: 'complete' }] : []
        this.form = data
        this.axiosSubject()
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    },
    // 学科字典项
    async axiosSubject() {
      // const params = { phaseCode: this.form.phaseCode }
      // const { data } = await axiosFactory({ url: 'res/listSubject', params })
      // this.dictSubject = data.map(item => ({ label: item.subjectName, value: item.subjectCode }))
      // const found = this.dictSubject.find(item => item.value === this.form.subjectCode)
      // if (!found) {
      //   this.form.subjectCode = ''
      // }
      this.$nextTick(() => {
        this.$refs.form.clearValidate('subjectCode')
      })
      const params = { code: this.form.phaseCode }
      const { data } = await axiosFactory({ url: 'live/getSubject', params })
      this.dictSubject = data
    },
    onSubmit() {
      this.$refs.form.validate(value => {
        if (value) {
          const payload = cloneDeep(this.form)
          payload.id = this.id
          payload.startTime = payload.starttime
          payload.endTime = payload.endtime
          // 视频
          debugger
          if (payload.recordingUrl.length > 0) {
            const file = payload.recordingUrl[0]
            payload.recordingUrl = file.url
            payload.contextId = file.contextId
            if (file.status !== 'complete') {
              this.$message.warning('请等待文件上传成功！')
              return
            }
          }
     
            if(payload.endTime==""){
              this.$message.warning('请等待文件上传成功！')
                  return
            }
          payload.thumbnail = payload.thumbnail.length > 0 ? payload.thumbnail[0].url : ''
          payload.phaseName = this.dictPhase.find(item => item.code === payload.phaseCode).name
          payload.subjectName = this.dictSubject.find(item => item.code === payload.subjectCode).name

          const params = pick(payload,
            [
              'id',
              'name',
              'startTime',
              'endTime',
              'organizer',
              'phaseCode',
              'phaseName',
              'subjectCode',
              'subjectName',
              'description',
              'contextId',
              'recordingUrl',
              'thumbnail'
            ]
          )
          // delete payload.time
          this.axiosSubmit(params)
        }
      })
    },
    getFileList(file) {
     
      let _this = this
      if (file.length > 0) {
         
        let videoElement = document.createElement('video');
        file.at(0).url=file.at(0).url.replace('http://', 'https://');
       // let preview = file.at(0).url.replace('http://', 'https://');
        videoElement.src =  file.at(0).url;

         debugger
        videoElement.addEventListener('loadedmetadata', function () {
          // 视频时长值的获取要等到这个匿名函数执行完毕才产生
          _this.videoDuration = Math.ceil(videoElement.duration)
          if (_this.videoDuration && _this.form.starttime) {
         
            let restime = moment(_this.form.starttime).add(_this.videoDuration, 's').format('YYYY-MM-DD HH:mm:ss')
            _this.form.endtime = restime
          }

        })
      } else {
        this.videoDuration = 0
        this.form.endtime = ''
      }
    },
    selecttime() {
      if (this.videoDuration) {
        let restime = moment(this.form.starttime).add(this.videoDuration, 's').format('YYYY-MM-DD HH:mm:ss')
        this.form.endtime = restime
      }
    },
    // 学科字典项
    async axiosSubmit(data) {
      let params = {
        st: window.localStorage.getItem('st'),
        tgt: window.localStorage.getItem('tgt')
      }
      const { code } = await axiosFactory({ url: 'live/addLive', method: 'post', params, data })
     
      if (code === '1') {
       
        const message = data.id ? '编辑成功！' : '新增成功！'
        this.$message.success(message)
        this.$router.back()
      }
    },
    onCancel() {
      this.$router.back()
    },
    // 获取学段数据
    async getPhase() {
      let { data } = await axiosFactory({ url: 'live/getPhase' })
      this.dictPhase = data
      console.log(data)
    }
  },
  watch: {
    // videoDuration(val){
    //   if(val&&this.form.starttime){
    //     let restime = moment(this.form.starttime).add(val,'s').format('YYYY-MM-DD HH:mm:ss')
    //     this.form.endtime = restime
    //   }
    // }
  }
}
</script>

<style lang="less">
.manage-course-create {
  .form-buttons {
    text-align: center;
    .el-button {
      min-width: 76px;
    }
  }
  .upload-tip,
  .upload-tip1 {
    position: absolute;
    top: 0;
    left: 90px;
    width: 156px;
    height: 32px;
    font-size: 14px;
    text-align: center;
    border-radius: 6px;
    color: rgba(0, 0, 0, 0.65);
    background-color: #f5f9ff;
    i {
      color: #cfe4ff;
      margin-right: 8px;
    }
  }
  .upload-tip1 {
    width: 300px;
  }
  .el-textarea .el-input__count {
    bottom: -24px;
    line-height: 24px;
  }
}
// .p-manage{
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   background-color: #F4F5F7;
//   >.container{
//     flex:1;
//     margin-top: 16px;
//     margin-bottom: 16px;
//   }
// }
// .u-form{
//   width: 80%;
// }
// .u-upload-con{
//   display: flex;
//   .u-tip{
//     margin-left: 10px;
//     width: 156px;
//     height: 32px;
//     background-color: #F5F9FF;
//     color: #666;
//     font-size: 14px;
//     i{
//       color: #CFE4FF;
//     }
//   }
// }
</style>
